import React, { Component } from 'react';
import {Spinner} from 'react-bootstrap';
import RawDataSearchFile from './RawDataSearchFile';
import {InventoryUserMappedAction} from '../Dashboard/UserActions';
import {downLoadRawDataDump, downLoadRawDataDumpCompliance, downLoadRawDataDumpTransact, downLoadRawDataDumpcli,
  downLoadRawDataDumpcrm,  closeModalPopUp} from '../FileUpload/fileUploadAction';
import { connect } from 'react-redux';
import ShowModalPopUp from '../ShowModalPopUp';
class RawDataindex extends Component {
  componentDidMount(){    
    this.props.actioninventoryUserMapped()
  }
  render(){
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    } 
    
    return(<div  className={(style) ? 'user' : "userSmall"}>
    {(this.props.isPendingCsat === true || this.props.isPendingTransact === true ||  this.props.isPendingCompliance === true  )? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Downloading...</p> : null}
        {(this.props.showerror === true) ? (<ShowModalPopUp message={this.props.errmessage} falseShowModalPopUp={this.props.closeModalPopUp}/>) : null} 
    <RawDataSearchFile inventory={this.props.inventoryMapped} action={this.props} loginAction={this.props.loginAction}/>    
  </div>)   
  }
}
function mapStateToProps(state){
  return{
    size: state.UserReducer.large,    
    loginAction: state.LoginReducer.loginAction, 
    inventoryMapped: state.UserReducer.inventoryMapped, 
    showerror:  state.fileUploadReducer.showerror, 
    errmessage:  state.fileUploadReducer.errmessage,
    isPendingCsat : state.fileUploadReducer.isPendingCsat,
    isPendingTransact : state.fileUploadReducer.isPendingTransact,
    isPendingCompliance : state.fileUploadReducer.isPendingCompliance
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  downLoadRawDataDump: (b, c) => dispatch(downLoadRawDataDump(b, c)),
  downLoadRawDataDumpCompliance: (b, c) => dispatch(downLoadRawDataDumpCompliance(b, c)),
  downLoadRawDataDumpTransact: (b, c) => dispatch(downLoadRawDataDumpTransact(b, c)),
  downLoadRawDataDumpcli: (b, c) => dispatch(downLoadRawDataDumpcli(b, c)),
  downLoadRawDataDumpcrm: (b, c) => dispatch(downLoadRawDataDumpcrm(b, c)),
  closeModalPopUp:() => dispatch(closeModalPopUp())
})

export default connect(mapStateToProps, mapDispatchToProps)(RawDataindex);
